export const Marquee = () => {
  const phrase = "INTELLIGENCE DRIVEN · MISSION FOCUSED · ONIX · ";
  return (
    <div className="overflow-hidden border-y border-onix-line py-6 select-none" aria-hidden="true">
      <div className="flex w-max animate-marquee motion-reduce:animate-none">
        {[0, 1].map((n) => (
          <span
            key={n}
            className="font-serif font-bold text-2xl md:text-4xl uppercase text-transparent whitespace-nowrap pr-4"
            style={{ WebkitTextStroke: "1px var(--marquee-stroke)" }}
          >
            {phrase.repeat(4)}
          </span>
        ))}
      </div>
    </div>
  );
};
